import styled from 'styled-components'

export const IntroVidWrap = styled.div`
  display: grid;
  justify-items: center;
  align-items: center;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: black;

  #introVid {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    transform: translate(-50%, -50%);
  }

  .skipBtn {
    position: fixed;
    bottom: 12px;
    right: 15px;
    z-index: 200;
    font-weight: 900;
  }

  .unmuteBtn {
    position: fixed;
    bottom: 10px;
    left: 10px;
    z-index: 200;

    svg {
      stroke: white;
      fill: black;
      height: 30px;
    }
  }
`
